module.exports = __webpack_public_path__ + "static/media/onlineEd.ed4ddf66.jpg";